export enum AccountType {
  REGULAR = 'REGULAR',
  DEPOSIT = 'DEPOSIT',
  CREDIT = 'CREDIT',
  BROKER = 'BROKER',
}
